// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function fare_amount_encode(v) {
  return Js_dict.fromArray([
              [
                "currency",
                Decco.stringToJson(v.currency)
              ],
              [
                "minor_amount",
                Decco.intToJson(v.minor_amount)
              ]
            ]);
}

function fare_amount_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var currency = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "currency"), null));
  if (currency.TAG === /* Ok */0) {
    var minor_amount = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "minor_amount"), null));
    if (minor_amount.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                currency: currency._0,
                minor_amount: minor_amount._0
              }
            };
    }
    var e = minor_amount._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".minor_amount" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = currency._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".currency" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function last_slab_pricing_request_encode(v) {
  return Js_dict.fromArray([
              [
                "price_per_km",
                fare_amount_encode(v.price_per_km)
              ],
              [
                "price_per_min",
                fare_amount_encode(v.price_per_min)
              ]
            ]);
}

function last_slab_pricing_request_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var price_per_km = fare_amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "price_per_km"), null));
  if (price_per_km.TAG === /* Ok */0) {
    var price_per_min = fare_amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "price_per_min"), null));
    if (price_per_min.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                price_per_km: price_per_km._0,
                price_per_min: price_per_min._0
              }
            };
    }
    var e = price_per_min._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".price_per_min" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = price_per_km._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".price_per_km" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function slab_encode(v) {
  return Js_dict.fromArray([
              [
                "slab_km",
                Decco.intToJson(v.slab_km)
              ],
              [
                "price_per_min",
                fare_amount_encode(v.price_per_min)
              ],
              [
                "price_per_km",
                fare_amount_encode(v.price_per_km)
              ]
            ]);
}

function slab_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var slab_km = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "slab_km"), null));
  if (slab_km.TAG === /* Ok */0) {
    var price_per_min = fare_amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "price_per_min"), null));
    if (price_per_min.TAG === /* Ok */0) {
      var price_per_km = fare_amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "price_per_km"), null));
      if (price_per_km.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  slab_km: slab_km._0,
                  price_per_min: price_per_min._0,
                  price_per_km: price_per_km._0
                }
              };
      }
      var e = price_per_km._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".price_per_km" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = price_per_min._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".price_per_min" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = slab_km._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".slab_km" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function slab_pricing_request_encode(v) {
  return Js_dict.fromArray([
              [
                "distance_time_pricing_request",
                Decco.listToJson(slab_encode, v.distance_time_pricing_request)
              ],
              [
                "last_slab_pricing_request",
                last_slab_pricing_request_encode(v.last_slab_pricing_request)
              ]
            ]);
}

function slab_pricing_request_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var distance_time_pricing_request = Decco.listFromJson(slab_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "distance_time_pricing_request"), null));
  if (distance_time_pricing_request.TAG === /* Ok */0) {
    var last_slab_pricing_request = last_slab_pricing_request_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "last_slab_pricing_request"), null));
    if (last_slab_pricing_request.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                distance_time_pricing_request: distance_time_pricing_request._0,
                last_slab_pricing_request: last_slab_pricing_request._0
              }
            };
    }
    var e = last_slab_pricing_request._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".last_slab_pricing_request" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = distance_time_pricing_request._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".distance_time_pricing_request" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function core_structure_request_encode(v) {
  return Js_dict.fromArray([
              [
                "base_fare",
                fare_amount_encode(v.base_fare)
              ],
              [
                "waiting_rate_per_min",
                fare_amount_encode(v.waiting_rate_per_min)
              ],
              [
                "free_duration",
                Decco.intToJson(v.free_duration)
              ],
              [
                "free_kms",
                Decco.intToJson(v.free_kms)
              ],
              [
                "free_km_price_per_min",
                fare_amount_encode(v.free_km_price_per_min)
              ],
              [
                "slab_pricing_request",
                slab_pricing_request_encode(v.slab_pricing_request)
              ]
            ]);
}

function core_structure_request_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var base_fare = fare_amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "base_fare"), null));
  if (base_fare.TAG === /* Ok */0) {
    var waiting_rate_per_min = fare_amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "waiting_rate_per_min"), null));
    if (waiting_rate_per_min.TAG === /* Ok */0) {
      var free_duration = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "free_duration"), null));
      if (free_duration.TAG === /* Ok */0) {
        var free_kms = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "free_kms"), null));
        if (free_kms.TAG === /* Ok */0) {
          var free_km_price_per_min = fare_amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "free_km_price_per_min"), null));
          if (free_km_price_per_min.TAG === /* Ok */0) {
            var slab_pricing_request = slab_pricing_request_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "slab_pricing_request"), null));
            if (slab_pricing_request.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        base_fare: base_fare._0,
                        waiting_rate_per_min: waiting_rate_per_min._0,
                        free_duration: free_duration._0,
                        free_kms: free_kms._0,
                        free_km_price_per_min: free_km_price_per_min._0,
                        slab_pricing_request: slab_pricing_request._0
                      }
                    };
            }
            var e = slab_pricing_request._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".slab_pricing_request" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = free_km_price_per_min._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".free_km_price_per_min" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = free_kms._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".free_kms" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = free_duration._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".free_duration" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = waiting_rate_per_min._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".waiting_rate_per_min" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = base_fare._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".base_fare" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "geo_region_id",
                Decco.intToJson(v.geo_region_id)
              ],
              [
                "vehicle_id",
                Decco.intToJson(v.vehicle_id)
              ],
              [
                "name",
                Decco.stringToJson(v.name)
              ],
              [
                "start_instant",
                Decco.floatToJson(v.start_instant)
              ],
              [
                "core_structure_request",
                core_structure_request_encode(v.core_structure_request)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var geo_region_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "geo_region_id"), null));
  if (geo_region_id.TAG === /* Ok */0) {
    var vehicle_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_id"), null));
    if (vehicle_id.TAG === /* Ok */0) {
      var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
      if (name.TAG === /* Ok */0) {
        var start_instant = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start_instant"), null));
        if (start_instant.TAG === /* Ok */0) {
          var core_structure_request = core_structure_request_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "core_structure_request"), null));
          if (core_structure_request.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      geo_region_id: geo_region_id._0,
                      vehicle_id: vehicle_id._0,
                      name: name._0,
                      start_instant: start_instant._0,
                      core_structure_request: core_structure_request._0
                    }
                  };
          }
          var e = core_structure_request._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".core_structure_request" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = start_instant._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".start_instant" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".name" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = vehicle_id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".vehicle_id" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = geo_region_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".geo_region_id" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

export {
  fare_amount_encode ,
  fare_amount_decode ,
  last_slab_pricing_request_encode ,
  last_slab_pricing_request_decode ,
  slab_encode ,
  slab_decode ,
  slab_pricing_request_encode ,
  slab_pricing_request_decode ,
  core_structure_request_encode ,
  core_structure_request_decode ,
  t_encode ,
  t_decode ,
  
}
/* No side effect */
